import {
  type BuildDetailsFieldsParams,
  checkboxField,
  checklistField,
  field,
  leftColumn,
  readOnlyField,
  rightColumn,
  selectField,
  typedField,
  withLayout,
} from '../fieldHelpers';
import type { DetailField } from '../types';

type OpportunityInfoWithBrands = App.OpportunityInfo & {
  brands__c?: string;
};

type OfferWithSalesforceBrands = App.Offer & {
  sf_brands?: Array<string>;
};

function splitSalesforceMultiValue(value?: string | Array<string>) {
  const values = Array.isArray(value) ? value : (value ?? '').split(/[;,]/);

  return values.map((item) => item.trim()).filter(Boolean);
}

export function buildSystemInfoFields({
  offer,
  opportunity,
  opportunityId,
}: BuildDetailsFieldsParams): Array<DetailField> {
  const opportunityInfo = opportunity?.opportunity_info as OpportunityInfoWithBrands | undefined;
  const offerBrands = (offer as OfferWithSalesforceBrands | undefined)?.sf_brands;
  const brandOptions = splitSalesforceMultiValue(offerBrands ?? opportunityInfo?.brands__c);
  const brandsValue = brandOptions.join(';');

  return [
    withLayout(readOnlyField('18 Character ID', opportunityId, 'Salesforce-owned identifier.'), leftColumn),
    withLayout(readOnlyField('Created By', undefined), leftColumn),
    withLayout(readOnlyField('1st Payment Date', undefined), leftColumn),
    withLayout(field('ClonedFromOpportunity', undefined), leftColumn),
    withLayout(readOnlyField('View Previous Deal in LE', undefined), leftColumn),
    withLayout(readOnlyField('Days To Sign', undefined), leftColumn),
    typedField('Surcharge Duration', undefined, 'number', undefined, leftColumn),
    withLayout(readOnlyField('Total Duration Of the Opp', undefined), leftColumn),
    withLayout(field('Tag', undefined), leftColumn),
    typedField('Previous TTV (AUD)', undefined, 'number', undefined, leftColumn),
    withLayout(readOnlyField('Last Modified By', undefined), rightColumn),
    typedField('RSM Approved Date', undefined, 'datetime-local', undefined, rightColumn),
    withLayout(field('Form Assembly Key', undefined), rightColumn),
    withLayout(readOnlyField('Approval Counter', undefined), rightColumn),
    withLayout(readOnlyField('Reopen Counter', undefined), rightColumn),
    withLayout(readOnlyField('Surcharge % Coverage', undefined), rightColumn),
    withLayout(
      field('Scrape ID', undefined, 'This field holds the ID of the Scrape so that it can be used in URLs.'),
      rightColumn,
    ),
    withLayout(field('Performance Matrix', undefined), rightColumn),
    checklistField('Brands', brandsValue, brandOptions, undefined, rightColumn),
    checkboxField('RSM Approved', true, undefined, { ...rightColumn, inline: true }),
    checkboxField('Passed Validation', true, undefined, { ...rightColumn, inline: true }),
    checkboxField('IsLocked', undefined, undefined, { ...rightColumn, inline: true }),
    typedField('Data Collection Start', undefined, 'datetime-local', undefined, {
      columns: 2,
      group: 'Documents Received',
    }),
    typedField('Data Collection Received', undefined, 'datetime-local', undefined, {
      columns: 2,
      group: 'Documents Received',
    }),
    selectField('Data Collection Sheet Attached?', undefined, ['Yes', 'No'], undefined, {
      columns: 2,
      group: 'Documents Received',
    }),
    withLayout(readOnlyField('OpptyId', opportunityId), { columns: 2, group: 'Documents Received' }),
    typedField('Prop Info Collection Start', undefined, 'datetime-local', undefined, {
      columns: 2,
      group: 'Documents Received',
    }),
    typedField('Property Info Received', undefined, 'datetime-local', undefined, {
      columns: 2,
      group: 'Documents Received',
    }),
    withLayout(readOnlyField('Project Key', undefined), { columns: 2, group: 'Documents Received' }),
    selectField('Offer Ends In 7 Days', undefined, ['No', 'Yes'], undefined, {
      columns: 2,
      group: 'Documents Received',
    }),
  ];
}
